import { render, staticRenderFns } from "./fieldOrderForm.vue?vue&type=template&id=0bc307e0&scoped=true&"
import script from "./fieldOrderForm.vue?vue&type=script&lang=js&"
export * from "./fieldOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./fieldOrderForm.vue?vue&type=style&index=0&id=0bc307e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc307e0",
  null
  
)

export default component.exports